// export const API_URL = "http://localhost/api";
// export const BASE_URL = "http://localhost";
export const API_URL = "https://apitester.in/api";
export const BASE_URL = "http://localhost";
export const sampleClientFields = [
    "Identificacion",
    "Tipo_cliente",
    "Apellido_paterno",
    "Apellido_Materno",
    "Apellido_casada",
    "Primer_nombre",
    "Segundo_nombre",
    "Sexo",
    "Seguro_social",
    "Estado Civil",
    "Nom_Legal",
    "Nom_Comercial",
    "Direccion",
    "Fec_Nac_ini_op",
    "Email",
    "Telef_Casa",
    "Telef_Cel",
    "Lug_Trab",
    "Direc_Trab",
    "Posicion_Trab",
    "Ingreso_Mensual",
    "Fec_Ingreso_Trab",
    "Telef_Oficina",
    "Telef_Oficina_Ext",
    "Nom_Conyuge",
    "Apel_Conyuge",
    "Ced_Conyuge",
    "Nom_Padre",
    "Apel_Padre",
    "Nom_Madre",
    "Apel_Madre",
];

export const clientObjectFields = {
    "identificacion" :"Identificacion" ,
    "tipo_cliente":"Tipo_cliente",
    "apellido_paterno":"Apellido_paterno",
    "apellido_Materno":"Apellido_Materno",
    "apellido_casada":"Apellido_casada",
    "primer_nombre":"Primer_nombre",
    "segundo_nombre":"Segundo_nombre",
    "sexo":"Sexo",
    "seguro_social":"Seguro_social",
    "estado_civil":"Estado Civil",
    "nom_legal":"Nom_Legal",
    "nom_comercial":"Nom_Comercial",
    "direccion":"Direccion",
    "fec_nac_ini_op":"Fec_Nac_ini_op",
    "email":"Email",
    "telef_casa":"Telef_Casa",
    "telef_cel":"Telef_Cel",
    "lug_trab":"Lug_Trab",
    "direc_trab":"Direc_Trab",
    "posicion_trab":"Posicion_Trab",
    "ingreso_mensual":"Ingreso_Mensual",
    "fec_ingreso_trab":"Fec_Ingreso_Trab",
    "telef_oficina":"Telef_Oficina",
    "telef_oficina_Ext":"Telef_Oficina_Ext",
    "nom_conyuge":"Nom_Conyuge",
    "apel_conyuge":"Apel_Conyuge",
    "ced_conyuge":"Ced_Conyuge",
    "nom_padre":"Nom_Padre",
    "apel_padre":"Apel_Padre",
    "nom_madre":"Nom_Madre",
    "apel_madre":"Apel_Madre",
};

export const sampleContractFields = [
    "No_Contrato",
    "Identificacion",
    "Forma_pago",
    "Relación",
    "Inicio_relacion",
    "Final_relacion",
    "Monto_original",
    "Saldo_actual",
    "No_pagos",
    "Importe_de_pago",
    "Fecha_ultimo_pago",
    "Monto_ultimo_pago",
    "Fecha_liquidacion",
    "Días_de_atraso",
];

export const EMAIL_VALIDATE = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
